import { createMuiTheme } from '@material-ui/core/styles';
import { cyan, red } from '@material-ui/core/colors';
import muiButton from '@itt/frontend-scaffold-components/dist/Theme/muiButton';
import muiMenuItem from '@itt/frontend-scaffold-components/dist/Theme/muiMenuItem';
import muiPaginationItem from '@itt/frontend-scaffold-components/dist/Theme/muiPaginationItem';
import muiCheckbox from '@itt/frontend-scaffold-components/dist/Theme/muiCheckbox';
import muiAutocomplete from '@itt/frontend-scaffold-components/dist/Theme/muiAutocomplete';
import muiTextField from '@itt/frontend-scaffold-components/dist/Theme/muiTextField';
import muiTooltip from '@itt/frontend-scaffold-components/dist/Theme/muiTooltip';
import muiMenu from '@itt/frontend-scaffold-components/dist/Theme/muiMenu';
import muiLink from '@itt/frontend-scaffold-components/dist/Theme/muiLink';
import typography from '@itt/frontend-scaffold-components/dist/Theme/typography';

export default createMuiTheme({
  typography: { ...typography },
  palette: {
    primary: {
      main: cyan[500]
    },
    secondary: {
      main: red[500]
    },
    action: {
      hoverOpacity: 0.12
    }
  },
  overrides: {
    MuiButton: muiButton,
    MuiTooltip: muiTooltip,
    MuiMenuItem: muiMenuItem,
    MuiMenu: muiMenu,
    MuiPaginationItem: muiPaginationItem,
    MuiCheckbox: muiCheckbox,
    MuiTextField: muiTextField,
    MuiAutocomplete: muiAutocomplete,
    MuiLink: muiLink
  }
});
